// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { SuperBase } from '../Classes/SuperBase';
export class BSETBase extends SuperBase {
  subcontractorsCost: number;
  miscellaneousCost: number;
  projectManagementLabor: number;
  engineerLabor: number;
  specialistLabor: number;
  mechanicalEngineerLabor: number;
  electricalEngineerLabor: number;
  networkEngineerLabor: number;
  qualificationEngineerLabor: number;
  cyberSecEngineerLabor: number;
  energyEngineerLabor: number;
  lengEngineerLabor: number;
  programmingLabor: number;
  graphicsLabor: number;
  digitalDeploymentLabor: number;
  totalProjectManagementHours: number;
  totalEngineerHours: number;
  totalNetworkEngineerHours: number;
  totalQualificationEngineerHours: number;
  totalCyberSecEngineerHours: number;
  totalEnergyEngineerHours: number;
  totalLEngineerHours: number;
  totalGraphicsHours: number;
  totalProgrammingHours: number;
  totalDigitalDeploymentHours: number;
  totalSpecialistHours: number;
  totalMechanicalEngineerHours: number;
  totalElectricalEngineerHours: number;
  additionalLaborRate: number;
  additionalLaborHours: number;
  ppmCost: number;
  cpCost: number;
  laborTabNotes: string;
  nodeType: string;
}
